import type { JSONApiDataEntity } from '../../../src/types/json-api';
import { isResponseError, isValidationError } from '#queries/utils';
import type { FourthlineProcessAttributes } from './types';

export const KYC_COMPLETED_ERROR_CODE = 'kyc_process_completed';

export function isKycCompletedError(error: unknown): boolean {
  return (
    isResponseError(error) &&
    error.status === 422 &&
    isValidationError(error) &&
    error.data.errors?.[0]?.code === KYC_COMPLETED_ERROR_CODE
  );
}

export function isFourthlineEnvelope(
  response: unknown
): response is { data: JSONApiDataEntity<FourthlineProcessAttributes> } {
  return (
    typeof response === 'object' &&
    response !== null &&
    'data' in response &&
    typeof response.data === 'object' &&
    response.data !== null &&
    'attributes' in response.data
  );
}
